import { baseApi } from "redux/baseAPI";

export const sdohApi = baseApi.injectEndpoints({
  tagTypes: ["sdoh",],
  endpoints: (builder) => ({
    getSdoh: builder.query({
      query: (pid) => {
        if (pid) {
          return {
            url: `/sdoh/get.json`,
            method: "GET",
            params: { pid: pid },
          };
        }
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ["sdoh"],
    }),
    getSdohSettings: builder.query({
      query: (pid) => {
        if (pid) {
          return {
            url: `/sdoh/settings.json`,
            method: "GET",

          };
        }
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ["sdohSettings"],
    }),
    addSdoh: builder.mutation({
      query: (body,pid) => ({
        url: '/sdoh/add.json',
        method: 'POST',
        data: body,
        params: { pid: pid },
      }),
      transformResponse: (response, meta, arg) => response,
      invalidatesTags: (result, error, arg, meta) => ['sdoh'],
    }),
  }),
});

export const { useGetSdohQuery, useGetSdohSettingsQuery, useAddSdohMutation } = sdohApi;
